import { ChartConfig } from "app/components/ui/chart";

export const constants = {
  skillsLevel: ['novice', 'beginner', 'skillfull', 'experienced', 'expert'],
  languageLevel: [
    {
      key: 'elementary',
      value: 'Working knowledge',
    },
    {
      key: 'pre_intermediate',
      value: 'Good working knowledge',
    },
    {
      key: 'low_intermediate',
      value: 'Very good command',
    },
    {
      key: 'upper_intermediate',
      value: 'Highly proficient',
    },
    {
      key: 'advanced',
      value: 'Native speaker',
    },
    {
      key: 'a1',
      value: 'A1',
    },
    {
      key: 'a2',
      value: 'A2',
    },
    {
      key: 'b1',
      value: 'B1',
    },
    {
      key: 'b2',
      value: 'B2',
    },
    {
      key: 'c1',
      value: 'C1',
    },
    {
      key: 'c2',
      value: 'C2',
    },
  ],
};

export const individiualScoreOrder = [
  'jobTitle',
  'sector',
  'primarySkill',
  'secondarySkills',
  'technicalSkills',
  'experience',
  'degree',
  'certification',
  'preferredCompanies',
  'longevity',
  'gaps',
];

export const mapIndividualScore = {
  jobTitle: 'Job Title Match',
  sector: 'Sector Match',
  primarySkill: 'Primary Skill Match',
  secondarySkills: 'Secondary Skills Match (overall)',
  technicalSkills: 'Technical Skills Match (overall)',
  experience: 'Experience Match',
  degree: 'Education Match',
  certification: 'Certifications Match',
  preferredCompanies: 'Preferred Companies Match',
  longevity: 'Longevity Score',
  gaps: 'Gaps Score',
};

export const keyToValueLanguage = {
  elementary: 'Working knowledge',
  pre_intermediate: 'Good working knowledge',
  low_intermediate: 'Very good command',
  upper_intermediate: 'Highly proficient',
  advanced: 'Native speaker',
  a1: 'A1',
  a2: 'A2',
  b1: 'B1',
  b2: 'B2',
  c1: 'C1',
  c2: 'C2',
};

export const jdMatchStatus = {
  NA: 0,
  Sourced: 1,
  Interested: 2,
  'Not Interested': 3,
  'Good for Later': 4,
  Rejected: 5,
  Duplicate: 6,
  'Not Responding': 7,
  Submitted: 8,
  Interview: 9,
  Offered: 10,
};


// 

export const roleOptions = [
  { value: 'officeManager', label: 'Office Manager' },
  { value: 'practiceOwner', label: 'Practice Owner' },
  { value: 'dentist', label: 'Dentist' },
  { value: 'hygienist', label: 'Hygienist' },
  { value: 'dentistAssistant', label: 'Dentist Assistant' },
  { value: 'otherStaff', label: 'Other Staff' },
];

export const countryOptions = [
  { value: 'unitedStates', label: 'United States' },
  { value: 'canada', label: 'Canada' },
  { value: 'unitedKingdom', label: 'United Kingdom' },
  { value: 'australia', label: 'Australia' },
  { value: 'other', label: 'Other' },
];

// practice info
export const dentalSpecialties = [
  [
    { id: 'generalDentistry', label: 'General Dentistry' },
    { id: 'orthodontics', label: 'Orthodontics' }
  ],
  [
    { id: 'multiSpecialty', label: 'Multi-Specialty' },
    { id: 'endodontics', label: 'Endodontics' }
  ],
  [
    { id: 'pediatricDentistry', label: 'Pediatric Dentistry' },
    { id: 'periodontics', label: 'Periodontics' }
  ],
  [
    { id: 'prosthodontics', label: 'Prosthodontics' },
    { id: 'other', label: 'Other' }
  ]
];

// howDidYouHearAboutUs status
export const howDidYouHearAboutUs = [
  {
    id: 'friends family',
    label: 'Friends or Family',
  },
  {
    id: 'google',
    label: 'Google',
  },
  {
    id: 'social media',
    label: 'Social Media',
  },
  {
    id: 'doctor referral',
    label: 'Doctor Referral',
  },
  {
    id: 'other',
    label: 'Other',
  },
];

export const daysOfWeek = [
  {
    id: 'Mon',
    label: 'Mon',
  },
  {
    id: 'Tue',
    label: 'Tue',
  },
  {
    id: 'Wed',
    label: 'Wed',
  },
  {
    id: 'Thu',
    label: 'Thu',
  },
  {
    id: 'Fri',
    label: 'Fri',
  },
  {
    id: 'Sat',
    label: 'Sat',
  },
  {
    id: 'Sun',
    label: 'Sun',
  },
];

export const timeOptions = [
  {
    id: 'AM',
    label: 'AM',
  },
  {
    id: 'PM',
    label: 'PM',
  },
];

export const paidCampaignPlatform = {
  1: 'Google',
  2: 'Meta',
  3: 'Instagram',
}

export const requestSource = {
  1: 'Website',
  2: 'Phone Call',
  3: 'Chatbot',
  4: 'Voice Agent',
  5: 'Walk-In',
  6: 'Others',
}

export const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]


// how people find us
export const chartConfig = {
  count: {
    label: "Patients",
  },
  friendsOrFamily: {
    label: "Friends or Family",
    color: "#5B73F1",
  },
  google: {
    label: "Google",
    color: "#FFE773",
  },
  socialMedia: {
    label: "Social Media",
    color: "#FF85BC",
  },
  doctorReferral: {
    label: "Doctor Referral",
    color: "#55B494",
  },
  other: {
    label: "Other",
    color: "#FF9E7C",
  },
} satisfies ChartConfig

// Mapping source IDs to chart config keys and display names
export const sourceIdMapping = {
  1: { key: "friendsOrFamily", name: "Friends or Family" },
  2: { key: "google", name: "Google" },
  3: { key: "socialMedia", name: "Social Media" },
  4: { key: "doctorReferral", name: "Doctor Referral" },
  5: { key: "other", name: "Other" }
}


export interface SourceData {
  sourceId: number;
  sourceName: string;
  count: number;
}
